module.exports = __webpack_public_path__ + "static/img/company.90b5427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.jpg
// module id = d1eR
// module chunks = 12